<template>
  <v-card
      class="rounded-lg white" height="370"
  >
    <v-card-title class=" mr-3 mt-3 secondary--text" style="font-size: medium">
      لیست اسناد <span class=" info--text mr-2 ml-2">روز جاری</span>
      <v-spacer></v-spacer>
      <v-tooltip right >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="/report/lists/sanads">
            <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
          </v-btn>
        </template>
        مشاهده تمام اسناد
      </v-tooltip>
      <v-tooltip right color="secondary" >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab icon class="" href="sanad/form">
            <v-img class="" src="/img/icons/plus_doc.svg" max-width="26"></v-img>
          </v-btn>
        </template>
        ثبت سند جدید
      </v-tooltip>
    </v-card-title>
    <v-simple-table class="mr-2 ml-2 rounded-b-lg">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            شماره عطف
          </th>
          <th class="text-center">
            تاریخ
          </th>
          <th class="text-center">
            شرح سند
          </th>
          <th class="text-center">
            بدهکار
          </th>
          <th class="text-center">
            بستانکار
          </th>
          <th class="text-center">
            وضعیت
          </th>
          <th class="text-center">
            قطعی
          </th>
          <th class="text-center">
            مشاهده
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="sanad in sanads">
          <td class="text-center">{{sanad.local_id}}</td>
          <td class="text-center">{{sanad.date}}</td>
          <td class="text-center">{{sanad.explanation}}</td>
          <td class="text-center">{{sanad.bed | toMoney(0)}}</td>
          <td class="text-center">{{sanad.bes | toMoney(0)}}</td>
          <td class="text-center error--text " v-if="sanad.bed == 0 && sanad.bes == 0">خالی</td>
          <td class="text-center success--text " v-else-if="sanad.bed == sanad.bes">متوازن</td>
          <td class="text-center warning--text " v-else="sanad.bed != sanad.bes">نا متوازن</td>
          <td class="text-center error--text ">
            <v-icon class="success--text" v-if="sanad.is_defined">fa-check</v-icon>
            <v-icon class="error--text" v-else>fa-times</v-icon>
          </td>
          <td class="text-center">
            <v-tooltip right >
              <template v-slot:activator="{ on, attrs }">
              <v-btn @click="$router.push(to(sanad))" depressed icon class="info--text" v-bind="attrs" v-on="on">
              <v-img class="" src="/img/icons/doc_seen.svg" max-width="23"></v-img>
            </v-btn>
              </template>
              جزییات سند
            </v-tooltip>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

  </v-card>
</template>

<script>
export default {
  name: "LastDocuments",
  components: {
  },
  props: {
    id: {},
  },
  data() {
    return {
      sanads: null,
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(){
      this.request({
        url: this.endpoint('reports/currentDaySanadsReport?limit=5&offset=0&search='),
        method: "get",
        success: data => {
          this.sanads = data.results
        },
      })
    },
    to(item) {
      return {
        name: "SanadForm",
        params: {
          id: item.id,
        },
      };
    },

  },



}
</script>

<style scoped lang="scss"></style>

